import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {NbAuthModule} from '@nebular/auth';
import {NbRoleProvider, NbSecurityModule} from '@nebular/security';
import {AzureRoleProvider} from '../pages/auth/azure/azure-role-provider';
import {DataModule} from './data/data.module';
import {throwIfAlreadyLoaded} from './module-import-guard';
import {AnalyticsService} from './utils/analytics.service';
import {LayoutService} from "./utils/layout.service";

export const NB_CORE_PROVIDERS = [
  ...DataModule.forRoot().providers,
  ...NbAuthModule.forRoot({

    strategies: [],
    forms: {},
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        public: ['*'],
      },
      user: {
        parent: '',
        view: ['usersonly'],
        create: [],
        edit: [],
        remove: [],
      },
      supervisor: {
        parent: 'user',
        view: ['all'],
        create: ['*'],
        edit: ['*', 'displaySettings'],
        remove: ['*'],
        admin: ['view', 'all'],
      },
      administrator: {
        parent: 'supervisor',
        view: ['*'],
        create: ['*'],
        edit: ['*'],
        remove: ['*'],
        admin: ['system'],
      },
      superadmin: {
        parent: 'administrator',
        view: ['*'],
        create: ['*'],
        edit: ['*'],
        remove: ['*'],
        admin: ['setup'],
      },
    },
  }).providers,

  {
    provide: NbRoleProvider, useClass: AzureRoleProvider,
  },
  AnalyticsService,
  LayoutService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
